import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DbService } from "../../services/db/db.service";
import { PaymentService } from '../../services/payment/payment.service';
import { UtilService } from '../../services/utils/util.service';
import { Pricing } from '../../model/pricing.model';

@Component({
  selector: 'app-reseller',
  imports: [CommonModule, FormsModule],
  templateUrl: './reseller.component.html',
  styleUrl: './reseller.component.scss'
})
export class ResellerComponent implements OnInit, OnDestroy {

  // Event Listeners...............................................................
  private paymentStatusSubscription!: Subscription;

  // Bind Variables...............................................................
  // Visibility control
  isLoading = false;
  isModalOpen = false;
  isJoining = false;
  // Form input fields
  email: string = "";
  region: string = "";
  item: Pricing | undefined;
  resellerID: number = 0;
  // Available regions
  regions: string[] = ['UAE', 'Russia', 'China', 'Iran'];
  pricing: [Pricing] | undefined;

  constructor(private db: DbService, private payment: PaymentService, private util: UtilService) { }

  ngOnInit(): void {
    this.addEventListener();
    this.getResellerPricing();
  }

  ngOnDestroy(): void {
    this.removeEventListener();
  }

  getResellerPricing() {
    this.db.getResellerPricing().subscribe((result) => {
      console.log(result);
      if (result.status_code === 1) {
        this.pricing = result.data;
      }
    });
  }

  addEventListener(): void {
    this.paymentStatusSubscription = this.payment.paymentProcessStatus.subscribe((event) => {
      console.log('Payment Status:', event);
      if(event === "pay-success"){
        this.isLoading = true;
        this.db.getAllCoupons().subscribe((result) => {
          console.log("Data: ", result);
          if (result.status_code === 1) {
            const coupons = this.util.getCouponCodes(result.data, 5);
            console.log(coupons);
            var list = [];
            for (let i = 0; i < coupons.length; i++) {
              let coupon = { "user_id": this.resellerID, "code": coupons[i], "duration": this.item!.duration, "amount": this.item!.amount, "server_id": "" }; //(reseller_id, code, duration, amount, server_id)
              list.push(coupon);
            }
            const couponData = { "values": list };
            this.db.addResellerCoupon(couponData).subscribe((result) => {
              this.isLoading = false;
              console.log(result.message);
              this.openAndDownload(coupons);
            });
          } else {
            console.log(result);
            this.isLoading = false;
          }
        });
      }else{
        this.isLoading = false;
      }
    });
  }

  removeEventListener(): void {
    if (this.paymentStatusSubscription) {
      this.paymentStatusSubscription.unsubscribe();
    }
  }

  // Method to open the modal
  openModal() {
    this.isModalOpen = true;
  }

  // Method to close the modal
  closeModal() {
    this.isModalOpen = false;
    this.isJoining = false;
  }

  joinReseller() {
    this.isJoining = true;
    this.openModal();
  }

  createReseller() {
    if (this.email && this.region) {
      this.closeModal();
      this.isLoading = true;
      this.db.getResellerByEmail(this.email).subscribe((result) => {
        console.log(result);
        if (result.status_code === 1) {
          if (result.data.length > 0) {
            // Existing Reseller
            this.isLoading = false;
            this.util.showError("Error", "Existing Reseller");
          } else {
            // Create New Reseller
            const resellerData = { "email": this.email, "region": this.region, "balance": "0" };
            this.db.addReseller(resellerData).subscribe((result) => {
              console.log(result);
              this.isLoading = false;
              if (result.status_code === 1) {
                // New Reseller Added
                this.resellerID = result.data.insertId;
                this.util.showToast("Success", "Reseller Joined");
              } else {
                this.util.showError("Error", result.message);
              }
            });
          }
        } else {
          console.log("Invalid Email or Region");
          this.isLoading = false;
          this.util.showError("Error", result.message);
        }
      });
    } else {
      console.log("Invalid Email or Region");
      this.isLoading = false;
      this.util.showError("Error", "Invalid Email or Region");
    }
  }

  // Method to handle form submission
  initPayment() {
    if (this.email && this.region) {
      this.closeModal();
      this.isLoading = true;
      // Check existing reseller
      this.db.getResellerByEmail(this.email).subscribe((result) => {
        console.log(result);
        if (result.status_code === 1) {
          if (result.data.length > 0) {
            // Existing Reseller
            this.resellerID = result.data[0].id;
            this.payment.processPayment(this.resellerID, this.email, this.region, this.item);
          } else {
            // Create New Reseller
            const resellerData = { "email": this.email, "region": this.region, "balance": "0" };
            this.db.addReseller(resellerData).subscribe((result) => {
              console.log(result);
              if (result.status_code === 1) {
                // New Reseller Added Fetch ID
                this.db.getResellerByEmail(this.email).subscribe((result) => {
                  console.log(result);
                  if(result.status_code === 1) {
                    this.resellerID = result.data[0].id;
                    this.payment.processPayment(this.resellerID, this.email, this.region, this.item);
                  }else{
                    this.isLoading = false;
                  }
                });
              } else {
                console.log(result);
                this.isLoading = false;
              }
            });
          }
        } else {
          this.isLoading = false;
        }
      });
    } else {
      this.util.showError("Invalid Email or Region", 'Error');
    }
  }

  purchaseResellerCoupon(item: any): void {
    console.log(`Selected: ${item.amount}`);
    this.item = item;
    this.openModal();
  }

  openAndDownload(data: any) {
    var file = new Blob([data], { type: 'application/octet-stream' })
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
    var a = document.createElement('a');
    a.href = fileURL;
    a.target = '_blank';
    a.download = 'bill.pdf';
    document.body.appendChild(a);
    URL.revokeObjectURL(fileURL);
  }

}
